module.exports = __webpack_public_path__ + "media/containers/common/Images/icNurse-e2b018195bef0c6ab1564c673966c55f.png";